// extracted by mini-css-extract-plugin
export default {"portal-tabs__tabs":"tabWidget_portal-tabs__tabs__Hstey"};